<h2 mat-dialog-title>Edit Aliases</h2>
<p class="subtitle">{{ data.subTitle }}</p>
<mat-dialog-content>
  <form [formGroup]="form">
    <app-input-field
      label="Aliases"
      formControlName="aliases"
      type="chips-autocomplete"
    ></app-input-field>
  </form>
</mat-dialog-content>
<mat-dialog-actions>
  <button matButton="filled" (click)="submit()" [disabled]="form.invalid">Save Changes</button>
  <button matButton="elevated" (click)="close()">Close</button>
</mat-dialog-actions>
